export enum StatisticsType {
    REGISTRATION_PENDING = "PENDING",
    CANCELLATION_PENDING = "DECLINED_PENDING",
    ALMS_DONORS = "EVENT_ALM",
    DISCRETIONARY_MONEY_DONORS = "DISCRETIONARY_MONEY",
    BOHI_ETERNAL_TREE_DONORS = "BOHI_ETERNAL_TREE",
}

export const StatisticsTypeLabel = {
    [StatisticsType.REGISTRATION_PENDING]: "စာရင်းသွင်း ယောဂီများ",
    [StatisticsType.CANCELLATION_PENDING]: "စာရင်းပယ်ဖျက်ယောဂီများ",
    [StatisticsType.ALMS_DONORS]: "ဆွမ်း အလှူရှင်များ",
    [StatisticsType.DISCRETIONARY_MONEY_DONORS]: "အလှူငွေ အလှူရှင်များ",
    [StatisticsType.BOHI_ETERNAL_TREE_DONORS]: "ပဒေသာပင် အလှူရှင်များ",
}

export const StatisticsTypeLinkURL = {
    [StatisticsType.REGISTRATION_PENDING]: "/retreat-registrants",
    [StatisticsType.CANCELLATION_PENDING]: "/cancelled-registrants",
    [StatisticsType.ALMS_DONORS]: "/alms-donors",
    [StatisticsType.DISCRETIONARY_MONEY_DONORS]: "/fund-donors",
    [StatisticsType.BOHI_ETERNAL_TREE_DONORS]: "/padetha-donors",
}